<template>
    <div v-if="room">
        <header class="header">
            <div class="container">
                <div class="row align-items--center">
                    <div class="col-8 offset-2">
                        <h1 class="header__title">Scholar test</h1>
                    </div>

                    <div class="col-2 text--right">
                        <button type="button" @click="confirmClose" class="btn btn--icon btn--white">
                            <i class="material-icons">close</i>
                        </button>
                    </div>
                </div>
            </div>
        </header>

        <section class="container animated fadeIn">
            <div class="panel bg--layer-dark mb--lg">
                <div class="profile profile--horizontal">
                    <figure class="profile__avatar">
                        <span class="profile__avatar__img"><img src="/img/pictures/avatar-2.jpg" alt="" /></span>
                    </figure>

                    <div class="profile__text">
                        <div class="profile__name">{{ room.name }}</div>
                        <div class="profile__level">Level {{ room.level }} / {{ room.questionGroup.name }}</div>
                    </div>
                </div>
            </div>

            <standings :table="table"></standings>

            <h2 class="h1 text--center">Matches</h2>

            <p class="text--center opacity--sm">In progress</p>

            <matches-table :matches="inProgressMatches"></matches-table>

            <button type="button" :class="['btn', 'btn--block', 'btn--purple', 'mb--lg', {'btn--disabled': restartDisabled }]" @click="restart">Restart test</button>

            <p class="text--center opacity--sm">Ready</p>

            <matches-table :matches="finishedMatches"></matches-table>
        </section>

        <modal ref="confirmCloseModal" show="false" type="error">
            <template v-slot:message>
                Are you sure? No way back... :)
            </template>

            <template v-slot:buttons>
                <button type="button" @click="closeGame" class="btn btn--block btn--primary">Yes</button>
                <button type="button" @click="hideConfirmAlert" class="btn btn--block btn--green">No</button>
            </template>
        </modal>
    </div>
</template>

<script>
    import Standings from "./partial/Standings";
    import MatchesTable from "./partial/MatchesTable";

    export default {
        components: {MatchesTable, Standings},

        props: ['table', 'matches'],

        data: function () {
            return {
                room: null,
            }
        },

        methods: {
            restart() {
                if (this.restartDisabled) {
                    return
                }

                Quiz.$emit('scholar-game-restart')
            },

            confirmClose() {
                this.$refs.confirmCloseModal.open()
            },

            closeGame() {
                this.hideConfirmAlert()
                this.$router.push('/')
            },

            hideConfirmAlert() {
                this.$refs.confirmCloseModal.close()
            },
        },

        computed: {
            inProgressMatches() {
                return this.matches.filter((item) => item.status === 'in_progress')
            },

            finishedMatches() {
                return this.matches.filter((item) => item.status === 'finished')
            },

            orderedTable() {
                return collect(this.table).sortByDesc('point')
            },

            restartDisabled() {
                if (this.matches.count() && ! this.matches.filter((item) => item.status === 'in_progress').count()) {
                    return false
                }

                return true
            }
        },

        created() {
            Quiz.$on('scholar-room-created', (data) => {
                this.room = data
            })
        },

        beforeDestroy() {
            if (this.room) {
                this.unsubscribe('scholar-' + this.room.id)
            }
            Quiz.$off('scholar-room-created')
        }
    }
</script>
